import axios from "@/plugins/axios";

export const FileManagerService = {
  async getDates(type, dateFrom = null, dateTo = null) {
    try {
      const params = {
        type: type,
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }) 
      };

      const response = await axios.get('api/v1/file-manager/dates', { params });
      return response.data;
      
    } catch (error) {
      console.error('Error fetching file dates:', error);
      throw error;
    }
  },

  async getFile(fileUploadId) {
    try {
      const response = await axios.get(`api/v1/file-manager/files/${fileUploadId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching file details:', error);
      throw error;
    }
  }
};